<template>
  <SearchPage
    v-slot="{ hit }"
    endpoint="press-releases"
    :title="entity.title"
    group-by="group"
    :filter-titles="{
      organization: $texts('pressReleaseSender', 'Absender'),
    }"
    :search-result-titles="{
      singular: $texts('search.pressReleaseSingular', 'Medienmitteilung'),
      plural: $texts('search.pressReleasePlural', 'Medienmitteilungen'),
    }"
    :total-documents="total"
  >
    <SearchResultPressRelease v-bind="hit" />
  </SearchPage>
</template>

<script lang="ts" setup>
definePageMeta({
  name: 'press-releases',
  drupalFrontendRoute: true,
  ariaLive: 'off',
  languageMapping: {
    de: '/medien/medienmitteilungen',
    en: '/en/media/press-releases',
    fr: '/fr/medies/communiques-de-presse',
    it: '/it/media/comunicati-stampa',
  },
})

const { data: total } = await useAsyncGraphqlQuery(
  'totalPressReleaseCount',
  null,
  {
    transform: function (data) {
      return data.data.entityQuery.total
    },
    graphqlCaching: {
      client: true,
    },
  },
)

const { entity } = await useDrupalRouteQuery('page')
await renderPageDependencies()
</script>
